export default __webpack_public_path__ + "static/media/hamburger_music_on_button.95322fe3.png";